import React from 'react';
import {useSelector} from "react-redux";
import {get} from "lodash";
import { Card, Row, Col } from "antd";
import blogStyles from "../Blogs/styles.module.scss";
import './style.css';

const ContentApp = (props) => {
    const {contentApp} = useSelector(state => get(state, 'contentApp'));
    const createMarkup = () => {
        let description = contentApp && contentApp.content ? contentApp.content : '<p>Không tồn tại trang chính sách</p>';
        return { __html: description };
    }
    return (
        <>
            <Row>
                <Col lg={24} sm={24} xs={24}>
                    <Card className={blogStyles.card}>
                        <h1>{contentApp && contentApp.title ? contentApp.title : ''}</h1>
                        <div dangerouslySetInnerHTML={createMarkup()} className='editor'></div>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
export default ContentApp;